module.exports = __webpack_public_path__ + "img/5.c70fd61d.png";